import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bookinnovaforoutsttaion() {



const cardData = {
keyword: "Book Innova for Outstation Pune",
headingDescription: "Book Innova for Outstation Pune for comfortable and convenient private road travel with family, friends, corporate teams, and small groups. The spacious Innova offers practical seating, air conditioning, luggage capacity, and driver-assisted transportation for one-way journeys, round trips, weekend holidays, family tours, business travel, and long-distance intercity routes. Whether traveling from Pune to Mumbai, Lonavala, Mahabaleshwar, Nashik, Shirdi, Kolhapur, Goa, or other destinations, an Innova outstation cab provides a flexible way to keep passengers together while following a planned pickup, travel, and return schedule.",
topPlaces: [
{
title: "Mumbai",
description: "Mumbai is one of the most frequently traveled intercity destinations from Pune for business, family visits, airport transfers, shopping, events, and leisure travel. An Innova outstation cab provides comfortable private transportation for groups carrying luggage and allows passengers to travel directly between Pune and their selected Mumbai destination."
},
{
title: "Lonavala",
description: "Lonavala is a popular weekend getaway from Pune, attracting families, friends, corporate groups, and tourists. A spacious Innova is convenient for these short outstation trips because passengers can travel together with luggage and enjoy private transportation while visiting viewpoints, resorts, lakes, and nearby attractions."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is a well-known hill station suitable for family holidays, weekend trips, and group tours from Pune. An Innova outstation taxi provides comfortable seating and luggage space for passengers traveling together, while private driver-assisted transportation offers flexibility for sightseeing and return travel."
},
{
title: "Nashik",
description: "Nashik is an important destination for religious travel, tourism, business visits, and family journeys. An Innova provides a spacious option for the longer road trip from Pune, allowing groups to stay together and carry their belongings conveniently while traveling on a planned one-way or round-trip itinerary."
},
{
title: "Shirdi",
description: "Shirdi attracts devotees, families, and groups visiting the Sai Baba temple and surrounding religious attractions. Booking an Innova from Pune provides direct private transportation with enough seating and luggage capacity, making it convenient for passengers who want a coordinated journey and return trip."
},
{
title: "Kolhapur",
description: "Kolhapur is a popular destination for religious visits, business travel, family trips, and tourism in southern Maharashtra. An Innova outstation cab is suitable for groups traveling from Pune because the spacious cabin offers comfortable seating and practical luggage space for the intercity journey."
},
{
title: "Goa",
description: "Goa is a major long-distance holiday destination for families, friends, corporate groups, and tourists traveling from Pune. An Innova is well suited for this type of journey, offering air-conditioned seating, useful luggage capacity, and private driver-assisted transportation for passengers traveling together."
},
{
title: "Alibaug",
description: "Alibaug is a popular coastal destination for weekend vacations, family outings, and group getaways from Pune. An Innova outstation taxi can provide door-to-door travel with sufficient room for passengers and bags, making it convenient for travelers planning a private trip with multiple stops."
},
{
title: "Aurangabad",
description: "Aurangabad, officially Chhatrapati Sambhajinagar, is an important destination for heritage tourism, religious visits, and business travel. An Innova provides a comfortable private option for groups traveling from Pune, particularly when passengers want convenient transportation and adequate luggage space throughout the journey."
},
{
title: "Satara",
description: "Satara is a convenient outstation destination from Pune for family visits, business requirements, nature trips, and regional travel. An Innova cab can accommodate small groups comfortably while providing private transportation for one-way or return journeys according to the traveler's planned schedule."
}
],
services: [
{
name: "Innova Outstation Cab Pune",
description: "Innova Outstation Cab Pune provides spacious private transportation for passengers traveling from Pune to destinations across Maharashtra and neighboring states. With comfortable seating, air conditioning, luggage space, and driver assistance, it is suitable for families, groups, corporate teams, tourists, and long-distance travelers."
},
{
name: "Innova Outstation Taxi Pune",
description: "Innova Outstation Taxi Pune is a convenient choice for travelers who want private intercity transportation in a spacious vehicle. It can be arranged for one-way trips, round trips, weekend holidays, family tours, business travel, religious journeys, and longer routes from Pune."
},
{
name: "Innova Outstation Booking Pune",
description: "Innova Outstation Booking Pune allows passengers to plan their vehicle around the destination, passenger count, and travel schedule. The service can support planned departures from Pune for family vacations, corporate travel, sightseeing tours, weekend trips, airport connections, and intercity journeys."
},
{
name: "Innova Outstation Rental Pune",
description: "Innova Outstation Rental Pune provides flexible access to a spacious vehicle for longer journeys outside Pune. Travelers can use the rental for family holidays, group tours, business visits, weekend trips, sightseeing programs, and multi-day travel while keeping their group together in one vehicle."
},
{
name: "Innova on Rent for Outstation Pune",
description: "Innova on Rent for Outstation Pune is suitable for passengers planning private road trips beyond city limits. The spacious cabin and luggage area make it practical for families and groups carrying travel bags, while driver support helps passengers focus on their journey instead of driving."
},
{
name: "Innova Hire for Outstation Pune",
description: "Innova Hire for Outstation Pune offers a comfortable vehicle option for planned intercity travel from Pune. It can be arranged for holidays, religious visits, corporate trips, weddings, family functions, and tourist routes where passengers require a private 7-seater vehicle with driver assistance."
},
{
name: "Innova Cab for Outstation Trip Pune",
description: "Innova Cab for Outstation Trip Pune is designed for families and groups looking for a comfortable vehicle for longer road journeys. The spacious seating, air conditioning, and luggage capacity make it useful for weekend getaways, family vacations, sightseeing trips, and intercity transportation."
},
{
name: "Innova Taxi for Outstation Travel Pune",
description: "Innova Taxi for Outstation Travel Pune provides private transportation for travelers moving between Pune and destinations outside the city. The vehicle is suitable for business travel, family journeys, tourist trips, religious visits, and long-distance routes requiring comfortable seating and professional driver support."
},
{
name: "Innova for Long Distance Travel Pune",
description: "Innova for Long Distance Travel Pune offers a spacious cabin that can make extended road journeys more comfortable for passengers. It is suitable for families, groups, and corporate travelers carrying luggage and planning longer routes where private transportation provides greater scheduling flexibility."
},
{
name: "Innova Family Outstation Cab Pune",
description: "Innova Family Outstation Cab Pune is a practical option for families planning holidays, religious trips, weddings, and visits to relatives outside Pune. Passengers can travel together in one spacious vehicle with room for luggage while following a convenient pickup and drop itinerary."
},
{
name: "Innova Group Outstation Travel Pune",
description: "Innova Group Outstation Travel Pune allows friends, relatives, colleagues, and small groups to share one vehicle for their intercity journey. This helps simplify travel coordination while providing comfortable seating, luggage capacity, and private driver-assisted transportation for the entire group."
},
{
name: "Innova Corporate Outstation Cab Pune",
description: "Innova Corporate Outstation Cab Pune is suitable for executives, employees, clients, and business teams traveling between Pune and other cities. It can be used for meetings, conferences, site visits, corporate events, and business tours where comfortable group transportation is required."
},
{
name: "Innova Weekend Trip Cab Pune",
description: "Innova Weekend Trip Cab Pune is convenient for families and friends planning short holidays from Pune to nearby destinations. A private Innova provides enough seating and luggage space for the group while allowing travelers to follow their preferred departure, sightseeing, and return schedule."
},
{
name: "Innova One Way Outstation Cab Pune",
description: "Innova One Way Outstation Cab Pune provides a convenient private transportation option for passengers who need to travel from Pune to another city without immediately returning in the same vehicle. It can be useful for relocations, airport transfers, family visits, business travel, and planned intercity journeys."
},
{
name: "Innova Round Trip Outstation Cab Pune",
description: "Innova Round Trip Outstation Cab Pune is suitable when passengers need transportation for both the onward and return journey. Families, tourists, and groups can use the same private vehicle for holidays, religious trips, sightseeing programs, weekend travel, and scheduled visits outside Pune."
},
{
name: "Affordable Innova Outstation Cab Pune",
description: "Affordable Innova Outstation Cab Pune offers a practical way for families and groups to access the additional space of an Innova for intercity travel. It can be considered for weekend trips, family tours, business travel, sightseeing, religious journeys, and other planned outstation requirements."
},
{
name: "AC Innova Outstation Cab Pune",
description: "AC Innova Outstation Cab Pune provides an air-conditioned cabin for comfortable travel during extended road journeys. The combination of climate-controlled seating, useful luggage space, and private transportation makes it suitable for families, senior passengers, groups, and corporate travelers."
},
{
name: "Luxury Innova Outstation Cab Pune",
description: "Luxury Innova Outstation Cab Pune provides a premium travel environment for passengers planning special trips, family holidays, corporate journeys, weddings, and tourist travel. The spacious cabin and comfortable seating offer a more refined private transportation option for longer road journeys."
},
{
name: "7 Seater Innova Outstation Pune",
description: "7 Seater Innova Outstation Pune is ideal for families and small groups who want to travel together in one vehicle. The seating capacity helps reduce the need for multiple cars, while the spacious interior and luggage area provide practical comfort for holidays and long-distance travel."
},
{
name: "Innova Outstation Taxi Near Me Pune",
description: "Innova Outstation Taxi Near Me Pune is useful for travelers searching for a spacious vehicle close to their pickup area for an intercity journey. The service can support family travel, group tours, corporate trips, weekend holidays, religious visits, and long-distance routes from Pune."
},
{
name: "Innova Intercity Cab Pune",
description: "Innova Intercity Cab Pune provides private transportation between Pune and other cities for business, tourism, family visits, and personal travel. The spacious cabin makes it suitable for passengers who want to travel together with luggage while enjoying the convenience of direct point-to-point transportation."
},
{
name: "Innova Tourist Cab for Outstation Pune",
description: "Innova Tourist Cab for Outstation Pune is suitable for travelers exploring destinations outside Pune on customized sightseeing trips. Families and groups can use the vehicle for hill stations, heritage destinations, religious locations, coastal holidays, and multi-stop tours with driver-assisted transportation."
},
{
name: "Innova Outstation Car Rental Pune",
description: "Innova Outstation Car Rental Pune provides a flexible vehicle option for planned trips beyond Pune. It can support one-way travel, round trips, weekend holidays, family tours, corporate journeys, and multi-day itineraries where passengers need a spacious vehicle with comfortable seating and luggage capacity."
},
{
name: "Innova for Family Tour Pune",
description: "Innova for Family Tour Pune is well suited to families planning vacations, religious tours, sightseeing programs, and visits to relatives in other cities. The spacious cabin allows family members to travel together while carrying luggage and following a private itinerary suited to their trip."
},
{
name: "Innova Outstation Cab with Driver Pune",
description: "Innova Outstation Cab with Driver Pune provides chauffeur-assisted transportation for passengers traveling on longer routes from Pune. A professional driver can handle the road journey while families, groups, and business travelers focus on their activities, conversations, sightseeing, or relaxation during the trip."
}
],
tableData: [
["Innova Outstation Cab Pune"],
["Innova Outstation Taxi Pune"],
["Innova Outstation Booking Pune"],
["Innova Outstation Rental Pune"],
["Innova on Rent for Outstation Pune"],
["Innova Hire for Outstation Pune"],
["Innova Cab for Outstation Trip Pune"],
["Innova Taxi for Outstation Travel Pune"],
["Innova for Long Distance Travel Pune"],
["Innova Family Outstation Cab Pune"],
["Innova Group Outstation Travel Pune"],
["Innova Corporate Outstation Cab Pune"],
["Innova Weekend Trip Cab Pune"],
["Innova One Way Outstation Cab Pune"],
["Innova Round Trip Outstation Cab Pune"],
["Affordable Innova Outstation Cab Pune"],
["AC Innova Outstation Cab Pune"],
["Luxury Innova Outstation Cab Pune"],
["7 Seater Innova Outstation Pune"],
["Innova Outstation Taxi Near Me Pune"],
["Innova Intercity Cab Pune"],
["Innova Tourist Cab for Outstation Pune"],
["Innova Outstation Car Rental Pune"],
["Innova for Family Tour Pune"],
["Innova Outstation Cab with Driver Pune"]
],
whychoose: [
{
WhyChooseheading: "Comfortable Long-Distance Seating",
WhyChoosedescription: "The spacious Innova cabin provides useful room for passengers during extended road journeys. Families and groups can travel together with comfortable seating and luggage space, making the vehicle practical for trips that involve several hours on the road."
},
{
WhyChooseheading: "Suitable for One-Way and Round Trips",
WhyChoosedescription: "Different outstation plans can be accommodated through one-way or round-trip travel requirements. This flexibility is useful for passengers visiting relatives, attending events, taking holidays, relocating, or planning a return journey after completing their destination activities."
},
{
WhyChooseheading: "Ideal for Families and Groups",
WhyChoosedescription: "Families, friends, relatives, and small groups can use one spacious vehicle instead of coordinating multiple cars. Traveling together also makes it easier to manage luggage, pickup points, stops, and destination transfers throughout the trip."
},
{
WhyChooseheading: "Air-Conditioned Travel Environment",
WhyChoosedescription: "An air-conditioned cabin helps passengers remain comfortable during long intercity journeys and changing weather conditions. The combination of climate-controlled interiors and spacious seating makes the Innova a practical choice for families, senior travelers, tourists, and corporate passengers."
},
{
WhyChooseheading: "Professional Driver Assistance",
WhyChoosedescription: "Driver-assisted outstation travel allows passengers to focus on their trip instead of managing the road journey themselves. This can be especially useful on unfamiliar routes, multi-day tours, family vacations, business travel, and journeys involving several sightseeing stops."
},
{
WhyChooseheading: "Convenient for Weekend Holidays",
WhyChoosedescription: "An Innova can comfortably support short weekend trips to destinations around Maharashtra and nearby regions. Families and friends can carry their bags and travel together while maintaining greater flexibility over departure times, stops, sightseeing, and return schedules."
},
{
WhyChooseheading: "Practical for Corporate Travel",
WhyChoosedescription: "Corporate teams can use an Innova for intercity meetings, conferences, site visits, client transportation, and business tours. The spacious cabin allows employees or visiting professionals to travel together while a driver handles the journey between Pune and the destination."
},
{
WhyChooseheading: "Useful Luggage Capacity",
WhyChoosedescription: "Outstation journeys often involve more luggage than regular city travel, particularly for family holidays and multi-day tours. The Innova's practical luggage space makes it easier to carry travel bags and personal belongings while keeping passengers comfortably seated throughout the journey."
}
]
};















const faqData = [
{
question: "Can I book an Innova from Pune for an outstation trip?",
answer: "An Innova can be arranged from Pune for outstation travel to cities, pilgrimage destinations, hill stations, and other locations across different routes. Share your destination, travel date, passenger count, and trip duration with Citysky Cabs to plan the vehicle according to your journey."
},
{
question: "Which destinations can I visit by booking an Innova from Pune?",
answer: "Travellers can use an Innova for routes from Pune to destinations such as Mumbai, Goa, Nashik, Shirdi, Mahabaleshwar, Kolhapur, Aurangabad, Bangalore, Hyderabad, and other cities. The final route and travel schedule can be discussed based on your planned itinerary."
},
{
question: "Is an Innova comfortable for long-distance travel from Pune?",
answer: "For longer journeys, an Innova can be a practical choice for families and groups who prefer travelling together in one vehicle. Passengers can plan suitable breaks, carry their luggage, and follow a shared itinerary without having to coordinate multiple smaller cars during the trip."
},
{
question: "Can families book an Innova for an outstation holiday?",
answer: "Family groups can arrange an Innova for vacations, weekend journeys, religious tours, family visits, and multi-day holidays from Pune. The larger vehicle is useful when several family members are travelling together with luggage and want to maintain the same schedule throughout the journey."
},
{
question: "Can I book an Innova from Pune for a one-way journey?",
answer: "One-way Innova travel can be arranged for suitable outstation routes from Pune when passengers need transportation to another city or destination without a planned return journey in the same vehicle. Provide the pickup point, destination, date, and passenger details while making the enquiry."
},
{
question: "Is round-trip Innova rental available for outstation travel?",
answer: "Round-trip arrangements can be considered when travellers plan to return to Pune after completing their outstation visit. This option can work well for family holidays, pilgrimage tours, business visits, weddings, and sightseeing trips where the return schedule is known in advance."
},
{
question: "Can I take an Innova for a multi-day outstation trip from Pune?",
answer: "Multi-day Innova journeys can be planned for extended holidays, group tours, religious circuits, family functions, and business travel. When requesting the rental, mention the complete route, number of travel days, expected overnight stops, passenger count, and any special itinerary requirements."
},
{
question: "Can I carry luggage when travelling in an Innova from Pune?",
answer: "Passengers can provide details about the number and approximate size of their bags before confirming the vehicle arrangement. This is especially useful for family holidays, airport-linked trips, weddings, and multi-day journeys where travellers are likely to carry several suitcases and personal belongings."
},
{
question: "Can corporate groups book an Innova for outstation travel from Pune?",
answer: "Companies can arrange an Innova for client visits, business meetings, conferences, employee travel, training programs, industrial visits, and team outings outside Pune. Group transportation can be coordinated around office schedules, meeting locations, route requirements, and the expected duration of the business trip."
},
{
question: "How can I book an Innova for outstation travel from Pune with Citysky Cabs?",
answer: "To book an Innova, share your Pune pickup location, destination, travel date, passenger count, luggage details, preferred departure time, and whether the journey is one-way or round-trip. Citysky Cabs can use these details to coordinate the outstation taxi arrangement around your planned travel schedule."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rajendra More",
feedback:
"We booked an Innova from Pune for a family trip and had several bags because we were travelling for a few days. Keeping everyone in one vehicle made the journey much easier, especially during the longer stretches of the route. Citysky Cabs handled the booking details according to our travel schedule.",
rating: 5
},
{
id: 2,
name: "Miss. Riya Chavan",
feedback:
"I needed an Innova for an outstation journey with relatives and wanted enough space for everyone to travel together. The enquiry with Citysky Cabs was simple, and I could share the route, travel date, and passenger details before finalizing the arrangement. The overall experience was convenient for our trip.",
rating: 5
}
];

























    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Book Innova for Outstation Pune",
  "image": "https://www.cityskycab.in/assets/images/book-innova-for-outstation-pune.webp",
  "description": "Book Innova for Outstation Pune with Citysky Cabs for comfortable intercity journeys with family, friends, corporate groups or small travel parties. An Innova provides spacious seating, useful luggage capacity and a comfortable AC environment for longer highway trips from Pune to destinations across Maharashtra and other states. The service is suitable for one-way travel, round trips, airport transfers and planned multi-day journeys. Experienced drivers, convenient pickup arrangements and flexible travel options make Innova Outstation Cab Pune a practical choice for passengers looking for a dependable vehicle for extended road travel.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/book-innova-for-outstation-pune"
  }
};



    return (
        <div>


<Helmet>
  <title>
    Book Innova for Outstation Pune | Innova Outstation Taxi for Long Distance Trips | +91 8554819191
  </title>

  <meta
    name="description"
    content="Book an Innova for outstation travel from Pune with Citysky Cabs. Spacious AC seating, experienced drivers and flexible one-way or round-trip options for comfortable long-distance journeys."
  />

  <meta
    name="keywords"
    content="Innova Outstation Cab Pune, Innova Outstation Taxi Pune, Innova Outstation Booking Pune, Book Innova for Outstation Pune, Innova Outstation Rental Pune, Innova Outstation Car Pune, Innova Outstation Hire Pune, Innova Outstation on Rent Pune, AC Innova Outstation Cab Pune, Innova One Way Cab Pune, Innova Round Trip Pune, Innova Long Distance Taxi Pune, Innova Outstation Taxi Service Pune, Innova Outstation Car Rental Pune, 7 Seater Innova Outstation Pune, Innova Highway Cab Pune, Pune Outstation Innova Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bookinnovaforoutsttaion;